import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  setFilterAValueWithUpdate,
  setFilterBValueWithUpdate,
  setSearchValueWithUpdate,
} from '../../../../redux/actions/filterActions';
import { formatFilterText } from '../../../../utils/formatFilterText';
import { tabHasTag } from '../../../../utils/parseTabTags';
import styles from './index.module.scss';

const StaticPodheader = ({ data = {}, path = '', currentSection = '', tag = '' }) => {
  const dispatch = useDispatch();

  // Получаем данные current_tab из Redux store
  const currentTabData = useSelector((state) => state.currentTab);

  // Получаем данные others из Redux store
  const others = useSelector((state) => state.others_data.others);

  // Временно закомментируем useEffect до объявления shouldShowFilters
  // React.useEffect(() => {
  //
  //   if (quote) {
  //   } else {
  //   }
  // }, [quote, tag, shouldShowFilters, searchValue]);

  // Получаем данные фильтров
  const publicationFilterA = currentTabData.publication_filter_a || [];
  const publicationFilterB = currentTabData.publication_filter_b || [];

  // Получаем текущие значения фильтров из Redux
  const selectedFilterA = currentTabData.filter_a_value || publicationFilterA[0] || '';
  const selectedFilterB = currentTabData.filter_b_value || publicationFilterB[0] || '';
  const searchValue = currentTabData.search_value || '';

  // Локальное состояние для поля поиска (не связано с Redux)
  const [localSearchValue, setLocalSearchValue] = useState(searchValue);

  // Синхронизируем локальное состояние с Redux при изменении search_value
  React.useEffect(() => {
    setLocalSearchValue(searchValue);
  }, [searchValue]);

  // Логирование для отладки
  //   selectedFilterA,
  //   selectedFilterB,
  //   filter_a_value: currentTabData.filter_a_value,
  //   filter_b_value: currentTabData.filter_b_value,
  //   publicationFilterB,
  // });

  // Обработчики изменения фильтров
  const handleFilterAChange = (event) => {
    dispatch(setFilterAValueWithUpdate(event.target.value));
    setLocalSearchValue(''); // Сбрасываем текст в поле поиска
  };

  const handleFilterBChange = (event) => {
    dispatch(setFilterBValueWithUpdate(event.target.value));
    setLocalSearchValue(''); // Сбрасываем текст в поле поиска
  };

  const handleSearchChange = (event) => {
    // Обновляем только локальное состояние, не Redux
    setLocalSearchValue(event.target.value);
  };

  const handleSearchSubmit = () => {
    // При нажатии кнопки "Искать" обновляем Redux
    dispatch(setSearchValueWithUpdate(localSearchValue));
    // Сбрасываем текст в поле поиска после отправки
    setLocalSearchValue('');
  };

  // Проверяем, нужно ли показывать фильтры (только для тега sh_podheader)
  const shouldShowFilters = tabHasTag(tag, 'sh_podheader');

  // Состояние для случайной цитаты
  const [randomQuote, setRandomQuote] = React.useState(null);

  // Обработка цитат из others (после объявления shouldShowFilters)
  React.useEffect(() => {
    if (others && Array.isArray(others)) {
      // Создаем массив для записи данных
      const quoteArray = [];

      // Обрабатываем quote если el.tab_tag == "quote"
      const quoteData = others.find((el) => el.tab_tag === 'quote');

      if (quoteData) {
        // Делаем цикл по quoteData.data
        if (quoteData.data && Array.isArray(quoteData.data)) {
          quoteData.data.forEach((el, index) => {
            // Переводим el.content в объект (без цикла)
            let contentObject = {};
            if (el.content) {
              try {
                // Если это JSON строка, парсим её
                if (typeof el.content === 'string') {
                  contentObject = JSON.parse(el.content);
                } else {
                  // Если это уже объект, копируем
                  contentObject = { ...el.content };
                }
              } catch (error) {
                contentObject = { contentValue: el.content };
              }
            }

            // Добавляем block_content в массив
            if (contentObject) {
              quoteArray.push({
                text: contentObject[0].block_content[0].content_text,
                autor: contentObject[0].block_content[1].content_text,
              });
            }
          });
        } else {
        }

        // Выводим массив в лог

        // Выбираем случайный элемент из массива
        if (quoteArray.length > 0) {
          const randomIndex = Math.floor(Math.random() * quoteArray.length);
          const selectedQuote = quoteArray[randomIndex];
          setRandomQuote(selectedQuote);
        }
      } else {
      }
    }
  }, [others]);

  return (
    <div className={styles.staticPodheader}>
      <div className={styles.content}>
        {/* Блок с названием */}
        <div className={styles.titleBlock}>
          <h2 className={styles.title}>
            {(currentTabData.show_name || data.title || 'Статичный Подзаголовок').toLowerCase()}
          </h2>
          {currentTabData.description || data.description ? (
            <p className={styles.description}>{currentTabData.description || data.description}</p>
          ) : null}
        </div>

        {/* Блок с фильтрами - показываем только если тег содержит sh_podheader */}
        <div className={styles.filtersBlock}>
          {shouldShowFilters && (
            <>
              {/* Поле поиска слева */}
              <div className={styles.searchContainer}>
                <label className={styles.searchLabel} htmlFor='search'>
                  поиск по разделу:
                </label>
                <div className={styles.searchInputContainer}>
                  <input
                    id='search'
                    type='text'
                    className={styles.searchInput}
                    value={localSearchValue}
                    onChange={handleSearchChange}
                    placeholder='Введите поисковый запрос'
                  />
                  <button
                    type='button'
                    className={styles.searchButton}
                    onClick={handleSearchSubmit}
                    title='Искать'>
                    →
                  </button>
                </div>
              </div>

              {/* Фильтры справа */}
              <div className={styles.filtersGroup}>
                {publicationFilterB.length > 1 && (
                  <div className={styles.radioContainer}>
                    <label className={styles.filterLabel}>показать:</label>
                    <div className={styles.radioGroup}>
                      {publicationFilterB.map((item, index) => (
                        <label key={index} className={styles.radioLabel}>
                          <input
                            type='radio'
                            name='filterB'
                            value={item}
                            checked={selectedFilterB === item}
                            onChange={handleFilterBChange}
                            className={styles.radioInput}
                          />
                          <span className={styles.radioText}>{formatFilterText(item)}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                )}
                {publicationFilterA.length > 1 && (
                  <div className={styles.filterContainer}>
                    <label className={styles.filterLabel} htmlFor='filterA'>
                      тип деформации:
                    </label>
                    <select
                      id='filterA'
                      className={styles.filterSelect}
                      value={selectedFilterA}
                      onChange={handleFilterAChange}>
                      {publicationFilterA.map((item, index) => (
                        <option key={index} value={item}>
                          {formatFilterText(item)}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </div>
            </>
          )}

          {/* Блок с цитатой - показывается при теге podheader если есть цитата */}
          {!shouldShowFilters &&
            randomQuote &&
            randomQuote.text &&
            randomQuote.text.trim() !== '' &&
            tag &&
            tag.includes('podheader') &&
            searchValue === '' && (
              <div className={styles.quoteContent}>
                <p className={styles.quoteText}>{randomQuote.text}</p>
                <p className={styles.quoteAuthor}>{randomQuote.autor}</p>
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default StaticPodheader;
